import React from 'react';
import '../e-input/Input.scss';

const StrBeforeHash = (props) => {
  const params = props.params;
  const secretKey = props.sk;
  let paramsCount = 0;
  for(let key in params) {
    paramsCount++;
  }

  function getUrlColorString() {
    let colors = ["#00DB30", "#38DBFF", "#646464", "#C7D900", "#C972FF", "#FF9C7D", "#BA55D3", "#1E90FF", "#DAA520", "#FF00FF", "#000000", "#0000FF"];

    const values = [...Object.values(params), secretKey];
    return values.map((val, i) => {
      const color = colors[i];
      const paramStyle = {'color': color};
      return <span key={i} style={paramStyle}>{val}</span>;
    });
  }

  return (
      <div className="str-before-hash">
        <span className="color-string">
          {getUrlColorString()}
        </span>
      </div>);
};

export default StrBeforeHash;
